import { render } from "./Checkbox.vue?vue&type=template&id=af5fdd50&scoped=true"
import script from "./Checkbox.vue?vue&type=script&lang=js"
export * from "./Checkbox.vue?vue&type=script&lang=js"

import "./Checkbox.vue?vue&type=style&index=0&id=af5fdd50&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af5fdd50"]])

export default __exports__